/**
 * Middleware para verificar se o sistema está em modo de manutenção
 * @param {Object} to - Rota de destino
 * @param {Object} from - Rota de origem
 * @param {Function} next - Função para continuar navegação
 * @returns {boolean} - true se deve continuar o fluxo normal, false se já redirecionou
 */
export function maintenanceMode(to, from, next) {
    // Verifica se a variável de ambiente MAINTENANCE_MODE está ativa
    const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true'

    // Se não está em modo de manutenção, continua normalmente
    if (!isMaintenanceMode) {
        return true
    }

    // Se está em modo de manutenção e não é a página de manutenção, redireciona
    if (to.name !== 'maintenance') {
        next({ name: 'maintenance' })
        return false
    }

    // Se já está na página de manutenção, continua
    return true
}
